export default {
    setSelectedSite(state, site) {
        state.selectedSite = site
    },
    setSelectedPackagingProject(state, project) {
        console.log('Set selected packaging project: ', project)
        state.selectedPackagingProject = project
        if(project === null){
            state.packagingData = null
        }
    },
    setQueryData(state, queryData) {
        state.searchQueryData = queryData
        console.log('Set query data mutation: ', state.searchQueryData)
    },
    setPackagingData(state, data) {
        state.packagingData = data
    },
    setDpLegendSelection(state, selection) {
        state.dpLegendSelection = selection
    },
    setSelectedPackagingDevice(state, packagingDevice) {
        state.selectedPackagingDevice = packagingDevice
    },
    updatePackagingForDevice(state, data) {
/*        dataPackgeId: response.dataPackgeId,
            message: response.message,
            packageDataset: dataset*/
        let selectedProject = JSON.parse(JSON.stringify(state.selectedPackagingProject))
        if(data && data.packageDataset){
            if(selectedProject.devices && selectedProject.devices.length > 0){
                const index = selectedProject.devices.findIndex(device => device.siteId === data.packageDataset.siteId)
                if(index !== -1){
                    let newDevice = JSON.parse(JSON.stringify(selectedProject.devices[index]))
                    newDevice.packagedDataset = data.packageDataset
                    newDevice.processingStatus = 'DataPackaged'
                    selectedProject.devices.splice(index, 1, newDevice)
                }
            }
        }
        state.selectedPackagingProject = selectedProject
    },
}
